import React, { Component, useState } from 'react';
import { Grid, ListItem } from '@material-ui/core';
import Typo from '../../components/CustomTypo';
import { ArrowDownIcon, BackOnPrimaryIcon } from '../../components/icons'
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import t from '../../utils/translateUtil';
import classNames from 'classnames'
import { Currencies } from '../../../Currencies';
import { getCurrencySymbol } from '../../utils/util';
const styles = theme => ({

    product_item: {
        backgroundColor: theme.palette.background.card,
        borderRadius: theme.shape.borderRadius2x,
        padding: theme.spacing(3, 5, 3, 5),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        border: "2px solid",
        borderColor: theme.palette.background.secondary,
        cursor:'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
            marginBottom: 0,
        },
    },
    product_item_selected: {
        backgroundColor: theme.palette.background.card,
        borderTopLeftRadius: theme.shape.borderRadius2x,
        borderTopRightRadius: theme.shape.borderRadius2x,
        borderBottom: "1px solid",

        borderBottomColor: theme.palette.border.primary,
        padding: theme.spacing(3, 5, 3, 5),
        marginTop: theme.spacing(2),
        marginBottom: 0,
        cursor:'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
            marginBottom: 0,
        },
    },
    menuItemContainer: {
        backgroundColor: theme.palette.background.card,
        borderBottomLeftRadius: theme.shape.borderRadius2x,
        borderBottomRightRadius: theme.shape.borderRadius2x,
    },
    price:{
        position:'absolute',
        right: theme.spacing(3)
    },
    border_require:{
        borderColor: theme.palette.background.icon,
    }
})

function VariantsItemView(props) {

    const [listItemToShow, setListItemShow] = useState(null);

    const onShowListItem = (key) =>{

        if (listItemToShow && listItemToShow === key)
            setListItemShow(null)
        else
            setListItemShow(key)
    }
    const onSelectItem = (key, variant) =>{
        setListItemShow(null)
        props.onSelectedVariation(key, variant)
    }
    const checkSelectedItem = (variant) =>{
        var variantSelected = [];
        var variationSelected = props.variationSelected;
        //console.log('variationSelected========',variationSelected)
        if (variationSelected.length > 0) {
            variationSelected.forEach(selected => {
                if (selected.key === variant.key) {
                    variantSelected = selected
                }
            });
        }
        return variantSelected;
    }
    const checkRequire = (variantSelected, variant) =>{
        var isRequire = false;

        if (props.showValidationVariant) {
            if (variantSelected.length == 0) {
                isRequire = true;
            } else {
                var findVariant = variantSelected.filter(v => v.key == variant.key);
                // console.log("findVariant:",findVariant);
                if (!findVariant || findVariant.length == 0) {
                    isRequire = true;
                }
            }
        }
        return isRequire
    }
    const renderComponents = (variations, classes) =>{
        var componentsView = [];
        variations.forEach((item, index) => {
            var varianSelect = checkSelectedItem(item);
            var isRequire = checkRequire(props.variationSelected, item);
            //console.log('isRequire=====',isRequire)
            componentsView.push(
                <Grid item key={index}>
                    <Grid xs={12} item container direction="row"
                    className={classNames(listItemToShow === item.key ? classes.product_item_selected : classes.product_item,isRequire ? classes.border_require : undefined)}
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    onClick={() => onShowListItem(item.key)}
                    data-variant-item={item.key}
                    data-variant-label={item.label}
                >
                    <Grid xs={10} item>
                        <Typo variant="subtitle2">{item.label}</Typo>
                        {varianSelect && varianSelect.value ?<Typo variant="body1" >{varianSelect.value}</Typo>:<Typo color={isRequire ? "error" : "default"} variant="body1" >{t('select_from_the_list')}</Typo>}
                    </Grid>
                    <Grid xs={2} item container alignItems='center' justify='flex-end'>
                        <ArrowDownIcon />
                    </Grid>
                </Grid>
                <Grid xs={12} item className={classes.menuItemContainer}>
                    {renderProducts(item, classes)}
                </Grid>
                </Grid>
            )
        });
        return componentsView;
    }
    const renderProducts = (item, classes) =>{
        var componentsView = null;
        if (listItemToShow === item.key) {
            var variations = item.variations ? item.variations : [];
            componentsView = variations.map((variation, index) => {
                let currency_symbol = props.currency;
                currency_symbol = getCurrencySymbol(variation.currency ? variation.currency : null);
                return (
                    <ListItem button={true} key={index} onClick={() => onSelectItem(item.key, variation)} data-variant-product={item.key} data-variant-product-name={variation.value}>
                        <Typo variant="body1">{variation.value}</Typo>
                        <div className={classes.price}>
                            <Typo variant='subtitle2'>{currency_symbol}{variation.price.toFixed(2)}</Typo>
                        </div>
                    </ListItem>
                )
            })
        }
        if (componentsView) {
            return (<Grid item style={classes.listItemContainer}>
                <ListItem button={true} key={0} onClick={() => onSelectItem(item.key, { id: 'None', value: 'None' })} data-variant-none={"none"}>
                    <Typo variant="body1">{'None'}</Typo>
                </ListItem>
                {componentsView}
            </Grid>)
        }
        return <Grid />
    }
        const { variations,classes } = props;
        return (
            <div>
                {renderComponents(variations,classes )}
        </div>
        );
}
function VariantItems(props) {
    var components = props.variations.map((item, index) => {
        return (
            <ListItem button={true} key={index} onClick={() => props.onSelectedVariation(item)}>
                <Typo variant="body1">{item.value}</Typo>
                <div className={props.classes.price}>
                    <Typo variant='subtitle2'>{props.currency}{item.price.toFixed(2)}</Typo>
                </div>
            </ListItem>
        )
    })
    return components

}
export default withStyles(styles)(withTranslation()(VariantsItemView));